import { Table } from '../../Components/table.jsx';
import { router } from '@inertiajs/react';

export default function StatusPage({ aws }) {

    const instances = aws.instances || [];

    const shutdownInstance = (instanceId) => {
        // /admin/aws/instance/{instanceId}/shutdown
        router.put(`/admin/aws/instance/${instanceId}/shutdown`, {}, {
            onSuccess: () => {
                // Optionally, you can refresh the page or update the state to reflect the shutdown
                router.reload();
            },
            onError: (error) => {
                console.error("Failed to shutdown instance:", error);
                alert("Failed to shutdown instance. Please try again.");
            }
        });
    };

    const setLambdaStopperEnabled = (enabled) => {
        // /admin/aws/lambda/stopper/enabled
        router.put('/admin/aws/lambda/stopper/enabled', { enabled }, {
            onSuccess: () => {
                // Optionally, you can refresh the page or update the state to reflect the change
                router.reload();
            },
            onError: (error) => {
                console.error("Failed to set Lambda stopper enabled state:", error);
                alert("Failed to set Lambda stopper enabled state. Please try again.");
            }
        });
    };

    const InstanceIdLink = (instanceId) => (
        <a 
            href={`https://eu-central-1.console.aws.amazon.com/ec2/home?region=eu-central-1#InstanceDetails:instanceId=${instanceId}`} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-500"
        >
            {instanceId}
        </a>
    );

    const options = [
        {label: "Stopper Function Status", onClick: () => setLambdaStopperEnabled(!aws.stopper_enabled), checked: aws.stopper_enabled },
    ]

    const InstanceState = (state) => {
        const stateClasses = {
            running: 'bg-green-100 text-green-800',
            stopped: 'bg-red-100 text-red-800',
            pending: 'bg-yellow-100 text-yellow-800',
            terminated: 'bg-gray-100 text-gray-800',
        };
        
        return (
            <span className={`px-2 py-1 text-xs font-medium rounded-md ${stateClasses[state] || 'bg-gray-100 text-gray-600'}`}>
            {state}
            </span>
        );
    }

    const InstanceActions = (_, instance) => (
        <div className="flex gap-2">
            <button 
                className="text-sm font-medium text-red-600 hover:text-red-500 disabled:opacity-50" 
                onClick={() => shutdownInstance(instance.id)}
                disabled={instance.state !== 'running'}
            >
                Shutdown
            </button>
        </div>
    );

    const columns = [
        { key: 'id', label: 'Instance ID', sortable: true, width: 'w-1/6', display: InstanceIdLink },
        { key: 'state', label: 'State', sortable: true, width: 'w-1/6', display: InstanceState },
        { key: 'status', label: 'Status', sortable: true, width: 'w-1/6' },
        { key: 'actions', label: 'Actions', sortable: false, width: 'w-1/6', display: InstanceActions },
    ];
    
    return (
        <div className="flex flex-col items-center justify-center flex-grow gap-4">
            <h1 className="text-1xl font-thin font-semibold text-gray-900 sm:text-2xl lg:text-3xl">
                AWS System Status
            </h1>
{/* 
           <pre>
                {JSON.stringify(aws, null, 2)}
           </pre> */}

            <Table
                name="awsInstances"
                columns={columns}
                rows={instances}
                options={options}
            />

        </div>
    );
}
